import React, { useEffect, useState } from "react";
import { api, apiErr } from "@/lib/api";
import { useAuth, getRecentUsers } from "@/context/AuthContext";
import { formatGs } from "@/lib/format";
import { Modal, Btn, Input } from "@/components/ui/kit";
import { toast } from "sonner";
import { Repeat } from "lucide-react";

export const HandoverModal = ({ open, onClose, location, cash, onDone }) => {
  const { user, loginWithToken } = useAuth();
  const [counted, setCounted] = useState("");
  const [email, setEmail] = useState("");
  const [pass, setPass] = useState("");
  const [notes, setNotes] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => { if (open) { setCounted(""); setEmail(""); setPass(""); setNotes(""); } }, [open]);
  const others = getRecentUsers().filter((u) => u.email !== user?.email);
  const diff = counted !== "" && cash?.open ? Number(counted) - cash.expected_cash : null;

  const submit = async () => {
    if (counted === "") { toast.error("Ingresá el efectivo contado"); return; }
    setBusy(true);
    try {
      const { data } = await api.post("/cash/handover", { location, counted_amount: Number(counted) || 0, to_email: email.trim(), to_password: pass, notes });
      loginWithToken(data);
      toast.success(`Caja entregada a ${data.user.name} con ${formatGs(data.opening_amount)}`);
      if (data.alert) toast.warning("La diferencia supera la tolerancia: se notificó al administrador");
      window.dispatchEvent(new Event("cash-closed"));
      onDone();
    } catch (e) { toast.error(apiErr(e)); setPass(""); } finally { setBusy(false); }
  };

  return (
    <Modal open={open} onClose={onClose} title="Traspaso de turno">
      <div className="space-y-4" data-testid="handover-modal">
        {cash?.open && (
          <div className="rounded-lg bg-secondary p-3 text-sm flex justify-between"><span className="text-muted-foreground">Efectivo esperado</span><span className="font-data font-bold text-primary">{formatGs(cash.expected_cash)}</span></div>
        )}
        <div><label className="text-sm font-medium mb-1 block">Efectivo contado que entregás (Gs.)</label><Input type="number" value={counted} onChange={(e) => setCounted(e.target.value)} data-testid="handover-counted" autoFocus /></div>
        {diff !== null && <p className="text-sm">Diferencia: <span className={`font-data font-bold ${diff === 0 ? "text-emerald-500" : "text-amber-500"}`} data-testid="handover-diff">{formatGs(diff)}</span></p>}
        <div className="rounded-lg border border-primary/30 bg-primary/5 p-3 space-y-2">
          <p className="text-xs font-semibold text-primary">Quien recibe la caja ingresa sus datos</p>
          {others.length > 0 && (
            <div className="flex flex-wrap gap-1.5">
              {others.map((u) => (
                <button key={u.email} type="button" onClick={() => setEmail(u.email)} data-testid={`handover-pick-${u.email}`}
                  className={`text-xs px-2.5 py-1 rounded-full border transition-colors ${email === u.email ? "border-primary bg-primary/15 text-primary" : "border-border hover:bg-accent"}`}>{u.name}</button>
              ))}
            </div>
          )}
          <Input type="email" autoComplete="off" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Correo de quien recibe" data-testid="handover-email" />
          <Input type="password" autoComplete="new-password" value={pass} onChange={(e) => setPass(e.target.value)} placeholder="Contraseña de quien recibe" data-testid="handover-password" />
        </div>
        <div><label className="text-sm font-medium mb-1 block">Notas (opcional)</label><Input value={notes} onChange={(e) => setNotes(e.target.value)} data-testid="handover-notes" /></div>
        <p className="text-[11px] text-muted-foreground">Se cierra tu caja con este arqueo y se abre la del otro usuario con el mismo efectivo como monto inicial. La sesión pasa al nuevo usuario.</p>
        <div className="flex gap-2">
          <Btn variant="outline" onClick={onClose} className="flex-1">Cancelar</Btn>
          <Btn onClick={submit} disabled={busy} data-testid="handover-submit" className="flex-1"><Repeat className="w-4 h-4" /> Entregar caja</Btn>
        </div>
      </div>
    </Modal>
  );
};
